import {CallIcon} from '@logistics-frontend/blocks'
import React from 'react'

import {ActionPerformerCall, VoiceForwardingCall} from 'src/api/cargo-c2c/types'

import {ActionButton} from '../action-button'
import {useVoiceForwarding} from './hooks'

type Props = {
  action: ActionPerformerCall
}

export function PerformerCall(props: Props) {
  const {action} = props
  const method = action.communication_method
  const [{isPending}, pressHandler] = useVoiceForwarding(
    isVoiceForwardingCall(method) ? {forwardingID: method.forwarding_id} : {phone: method.phone_number},
  )

  return <ActionButton lead={<CallIcon />} loading={isPending} onPress={pressHandler} title={action.title} />
}

function isVoiceForwardingCall(method: ActionPerformerCall['communication_method']): method is VoiceForwardingCall {
  return method.type === 'voice_forwarding_call'
}
